import React, { useEffect, useState } from "react";
import TaxSkeleton from "./TaxSkeleton";
import NoFound from "./NoFound";
import DeletePopup from "./DeletePopup";
import { Bounce, toast } from "react-toastify";

const deleteIcon = `${EASYCOMMERCE.assets}admin/img/icons/delete.png`;
const deletehoverIcon = `${EASYCOMMERCE.assets}admin/img/icons/delete-hover.png`;
const editIcon = `${EASYCOMMERCE.assets}admin/img/icons/status-edit-icon.png`;

const TaxList = ({ handleEdit, handleAddNew }) => {
    const [taxClasses, setTaxClasses] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [shopDeletePopup, setShowDeletePopup] = useState(false);
    const [taxIdToDelete, setTaxIdToDelete] = useState(null);

    const showToast = (type, message) => {
        toast[type](message, {
            position: "top-right",
            style: {
                margin: "30px 0 0 0",
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "26px",
                color: "#fff",
            },
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    useEffect(() => {
        setIsLoading(true);

        fetch(`${EASYCOMMERCE.rest_base}/taxes`,{
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                setIsLoading(false);
                setTaxClasses(data.data.classes);
            });
    }, []);

    const handleDelete = () => {
        if (!taxIdToDelete) return;

        setShowDeletePopup(false);
        easycommerce_modal(true);

        fetch(`${EASYCOMMERCE.rest_base}/taxes/${taxIdToDelete}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                easycommerce_modal(false);

                if (data.success) {
                    setTaxClasses((prevData) =>
                        prevData.filter((item) => item.id !== taxIdToDelete)
                    );

                    showToast("success", data.data);
                    setTaxIdToDelete(null);
                } else {
                    showToast("error", data.data);
                    setTaxIdToDelete(null);
                }
            });
    };

    return (
        <>
            {!isLoading ? (
                <div className="bg-white mt-8">
                    {taxClasses.length > 0 ? (
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-ec-border">
                                    <th className="w-[30%] text-left text-ec-placeholder font-inter font-medium text-base leading-[26px] py-6">
                                        Class
                                    </th>
                                    <th className="w-[10%] text-left text-ec-placeholder font-inter font-medium text-base leading-[26px] py-6">
                                        Status
                                    </th>
                                    <th className="w-[50%] text-left text-ec-placeholder font-inter font-medium text-base leading-[26px] py-6">
                                        Regions
                                    </th>
                                    <th className="w-[10%]"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {taxClasses.map((taxClasses, index) => (
                                    <tr
                                        keys={index}
                                        className={
                                            index < taxClasses.length - 1
                                                ? "border-b border-ec-border"
                                                : ""
                                        }
                                    >
                                        <td className="py-6 font-inter text-base font-normal leading-[26px] text-ec-body">
                                            {taxClasses.name}
                                        </td>
                                        <td className="py-6 font-inter text-base font-normal leading-[26px] text-ec-body">
                                            {taxClasses.status ? (
                                                <span className="flex justify-start items-center gap-3">
                                                    <span
                                                        className={`w-3 h-3 rounded-full bg-[#00E91B]`}
                                                    ></span>

                                                    <span>Active</span>
                                                </span>
                                            ) : (
                                                <span className="flex justify-start items-center gap-3">
                                                    <span
                                                        className={`w-3 h-3 rounded-full bg-[#B8D1BB]`}
                                                    ></span>

                                                    <span>Inactive</span>
                                                </span>
                                            )}
                                        </td>
                                        <td className="py-6 font-inter text-base font-normal leading-[26px] text-ec-body">
                                            {taxClasses.regions}
                                        </td>
                                        <td className="flex w-[94px] py-6">
                                            <button
                                                onClick={() => {
                                                    handleEdit(taxClasses.id);
                                                }}
                                                type="button"
                                                className="w-10 h-8 bg-[#F8F8F8] mr-4 rounded-[4px] flex justify-center"
                                            >
                                                <img
                                                    className="h-8 w-8"
                                                    src={editIcon}
                                                    alt=""
                                                />
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setShowDeletePopup(true);
                                                    setTaxIdToDelete(
                                                        taxClasses.id
                                                    );
                                                }}
                                                className="w-10 h-8 bg-[#F8F8F8] mr-4 rounded-[4px] 
                                            flex items-center justify-center group hover:bg-[#FF3A521A]"
                                            >
                                                <img
                                                    className="w-[14px] h-[16px] block group-hover:hidden"
                                                    src={deleteIcon}
                                                    alt="delete-pricing"
                                                />
                                                <img
                                                    className="w-[14px] h-[16px] hidden group-hover:block"
                                                    src={deletehoverIcon}
                                                    alt="delete-pricing"
                                                />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <>
                            <NoFound handleAddNew={() => handleAddNew(true)} />
                        </>
                    )}
                </div>
            ) : (
                <TaxSkeleton />
            )}
            {shopDeletePopup && (
                <DeletePopup
                    deleteAction={() => {
                        setTaxIdToDelete(null);
                        handleDelete();
                    }}
                    discardAction={() => setShowDeletePopup(false)}
                />
            )}
        </>
    );
};

export default TaxList;
